import { AuditType } from '@/schema'

/**
 * Constants for Audit feature
 */

export const AUDIT_TYPES = {
  [AuditType.DOCUMENT_VIEWED]: 'Document Viewed',
}

// Query Keys
export const QUERY_KEY_AUDIT_LIST = 'audit-list'
export const QUERY_KEY_DOCUMENT_VIEW_AUDIT = 'document-view-audit'
export const QUERY_KEY_HISTORY_LIST = 'history-list'

export const AUDIT_LIST_QUERY_KEY = (params: (string | number)[]) =>
  [QUERY_KEY_AUDIT_LIST, ...(params ? [params] : [])] as const

export const DOCUMENT_VIEW_AUDIT_QUERY_KEY = (
  documentId: string,
  documentVersionId?: string
) => [QUERY_KEY_DOCUMENT_VIEW_AUDIT, documentId, documentVersionId] as const

export const HISTORY_LIST_QUERY_KEY = (params: unknown[]) =>
  [QUERY_KEY_HISTORY_LIST, ...params] as const

export const AUDIT_LIST_STALE_TIME = 20 * 1000 // 20 seconds - increased for better caching
export const AUDIT_LIST_REFETCH_INTERVAL = 3 * 60 * 1000 // 3 minutes
export const HISTORY_LIST_STALE_TIME = 0 // 0 seconds

// ---------------------------------------------------------------------------
// Activity type options for the History page filter
// Maps UI labels → API audit_type values
// ---------------------------------------------------------------------------

export const HISTORY_ACTIVITY_TYPE_OPTIONS = [
  { label: 'Company', value: 'COMPANY' },
  { label: 'Project', value: 'PROJECT' },
  { label: 'Deliverable Set', value: 'DELIVERABLE_SET' },
  { label: 'Document', value: 'DOCUMENT_LOG' },
] as const

export const HISTORY_DEFAULT_SORT = '-created_at'

export const ENTITY_HISTORY_QUERY_KEY = (
  entity: string,
  entityId: string,
  additionalFilters?: unknown
) => ['entity-history', entity, entityId, additionalFilters] as const
